/* eslint-disable @typescript-eslint/naming-convention */
import type {
  MainNavigationBlock,
  SecondaryNavigationBlock,
  SupportNavigationBlock
} from '@ps/web-martech-cms-types/SiteHeader';
import { Link, RawButton, useResolver } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import type { NavLinkProps } from 'react-router-dom';

import Icon from '../CMSHeader/components/CMSHeaderMenu/Icon';

import styles from './CMSResolverLink.scss';

type Props = (SupportNavigationBlock | SecondaryNavigationBlock | MainNavigationBlock) & {
  className?: string;
  onClick?: () => void;
  showTitle?: boolean;
  isActive?: NavLinkProps['isActive'];
  activeClassName?: string;
  customIcon?: React.ReactNode;
};

const CMSResolverLink: React.FC<Props> = ({
  url,
  resolver_tag,
  title,
  className,
  icon,
  track_id,
  target,
  showTitle = true,
  activeClassName,
  customIcon,
  isActive,
  onClick
}) => {
  let href = useResolver(resolver_tag);
  if (!resolver_tag) {
    href = url || '';
  }

  if (icon === 'PrimaryButton' || icon === 'SecondaryButton') {
    const variant = icon === 'PrimaryButton' ? 'primary' : 'secondary';
    return (
      <RawButton
        href={url}
        inverse
        size="small"
        variant={variant}
        className={styles.buttonLink}
        onClick={onClick}
      >
        {title}
      </RawButton>
    );
  }

  return (
    <Link
      href={href}
      target={target || undefined}
      trackText={track_id}
      className={classNames(className, styles.menuLink)}
      onClick={onClick}
      isActive={isActive}
      activeClassName={activeClassName}
    >
      {customIcon ? customIcon : <Icon icon={icon?.toLowerCase()} className={styles.icon} />}
      {showTitle && title}
    </Link>
  );
};

export default CMSResolverLink;
